export default __webpack_public_path__ + "static/media/logo_X.c9d69acf.png";